"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Game = void 0;
const phaser_1 = __importDefault(require("phaser"));
const zimporter_phaser_1 = require("zimporter-phaser");
const SplashScreen_1 = require("./SplashScreen");
const MainMenu_1 = require("./MainMenu");
const AboutScreen_1 = require("./AboutScreen");
const BookController_1 = require("./BookController");
const GlobalData_1 = require("./GlobalData");
const Preloader_1 = require("./Preloader");
class Game extends phaser_1.default.Scene {
    constructor() {
        super({ key: 'GameScene' });
        this.currentScreen = 'splash';
        this._frameCount = 0;
        this._lastTime = 0;
        /** Keep a reference to the active screen object for resize forwarding. */
        this.activeBook = null;
        this.activeMenu = null;
        /** Pending background preload of the Block frame scene. */
        this._blockPreload = null;
    }
    create() {
        zimporter_phaser_1.ZUpdatables.init(24);
        this._frameCount = 0;
        this._lastTime = performance.now();
        this._fpsText = this.add.text(10, 10, 'FPS: --', {
            fontSize: '24px',
            color: '#ffffff'
        }).setDepth(9999);
        this._showSplash();
    }
    // ─── Screen transitions ────────────────────────────────────────────────────
    _showSplash() {
        return __awaiter(this, void 0, void 0, function* () {
            this.currentScreen = 'splash';
            // Splash onComplete fires after 2 s; we use it to begin loading the menu
            // while the splash is still visible.
            const splash = new SplashScreen_1.SplashScreen(this, () => this._splashToMenu(splash));
            yield splash.load();
        });
    }
    /** Called by SplashScreen after its 2-second hold. Loads menu, then removes splash. */
    _splashToMenu(splash) {
        return __awaiter(this, void 0, void 0, function* () {
            const menu = this._buildMenu();
            yield menu.load(); // menu is added to scene (on top of splash)
            splash.destroy(); // splash is now hidden behind menu — safe to destroy
            this.currentScreen = 'menu';
            this.activeMenu = menu;
            this._blockPreload = BookController_1.BookController.preloadBlockScene(this);
        });
    }
    /** Constructs a MainMenu wired to this Game's callbacks. */
    _buildMenu() {
        GlobalData_1.GlobalData.counter = 0;
        let menu;
        menu = new MainMenu_1.MainMenu(this, () => this._showBook(), () => this._showAbout(), (lang) => {
            GlobalData_1.GlobalData.currentLang = lang;
            menu.reload();
        });
        return menu;
    }
    /** Loads a fresh menu. Called when returning from About or Book. */
    _showMenu() {
        return __awaiter(this, void 0, void 0, function* () {
            this.currentScreen = 'menu';
            const menu = this._buildMenu();
            yield menu.load();
            this.activeMenu = menu;
            this._blockPreload = BookController_1.BookController.preloadBlockScene(this);
        });
    }
    _showAbout() {
        return __awaiter(this, void 0, void 0, function* () {
            this.currentScreen = 'about';
            const menuToDestroy = this.activeMenu;
            this.activeMenu = null;
            // Show preloader on top of the menu — disables all menu buttons.
            const preloader = new Preloader_1.Preloader(this);
            preloader.show();
            // Pop the menu from the resize stack before About pushes itself on top.
            zimporter_phaser_1.ZSceneStack.pop();
            const about = new AboutScreen_1.AboutScreen(this, () => this._showMenu());
            yield about.load(); // about is added to scene on top of menu + preloader
            menuToDestroy === null || menuToDestroy === void 0 ? void 0 : menuToDestroy.destroy(); // menu is hidden behind about — safe to destroy
            preloader.hide();
        });
    }
    _showBook() {
        return __awaiter(this, void 0, void 0, function* () {
            this.currentScreen = 'book';
            const menuToDestroy = this.activeMenu;
            this.activeMenu = null;
            // Await the background preload (instant if it already finished).
            const preloadedScene = this._blockPreload ? yield this._blockPreload : undefined;
            this._blockPreload = null;
            const book = new BookController_1.BookController(this, () => {
                this.activeBook = null;
                this._showMenu();
            });
            this.activeBook = book;
            // book.load() keeps everything offscreen until the first page is ready,
            // so the menu stays fully visible throughout.
            yield book.load(preloadedScene);
            // Book is fully ready — now pop the menu and swap.
            zimporter_phaser_1.ZSceneStack.pop();
            menuToDestroy === null || menuToDestroy === void 0 ? void 0 : menuToDestroy.destroy();
        });
    }
    // ─── Called by Phaser update loop ─────────────────────────────────────────
    update(_time, delta) {
        // FPS counter
        this._frameCount++;
        const now = performance.now();
        const elapsed = now - this._lastTime;
        if (elapsed >= 1000) {
            const fps = (this._frameCount / elapsed) * 1000;
            this._fpsText.setText(`FPS: ${fps.toFixed(1)}`);
            this._fpsText.setDepth(9999);
            this._frameCount = 0;
            this._lastTime = now;
        }
        zimporter_phaser_1.ZUpdatables.update();
    }
    /** Called when the window resizes. */
    resize(width, height) {
        var _a;
        zimporter_phaser_1.ZSceneStack.resize(width, height);
        (_a = this.activeBook) === null || _a === void 0 ? void 0 : _a.resize(width, height);
    }
}
exports.Game = Game;
